module.exports = __webpack_public_path__ + "img/icon_deposit.96119567.svg";